import { useCallback, useState } from 'react';
import { useFunnelMapApiFacade } from '../../../../../apis/facades/funnel-map/useFunnelMapApiFacade';
import { PanelConsumer } from '../../../../panels/PanelsContext';
import { useConfigurationCanvasContext } from '../../../configuration-canvas/ConfigurationCanvasContext';
import { ProcessMiningDialog } from './ProcessMiningDialog';
import { processMiningPanelType } from './processMiningPanelType';
import { useErrorHandling } from '../../../../../hooks/useErrorHandling';
import { telemetry } from '../../../../../telemetry';
import { useDispatch } from 'react-redux';
import { addMultipleSfFunnels } from '../../../../../reducers/united-canvas/unitedCanvasReducer';
import { useSweepCanvasFitView } from '../../../../sweep-canvas/useSweepCanvasFitView';

export const CanvasUnitedProcessMiningDialog = () => {
  const { canvasCrmOrgId: crmOrgId } = useConfigurationCanvasContext();
  const { post_aiProcessMining } = useFunnelMapApiFacade();
  const { errorHandlingBuilder } = useErrorHandling();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { fitView } = useSweepCanvasFitView();

  const onConfirm = useCallback(
    (maybeClosePanel: () => void) => async (objectName: string) => {
      errorHandlingBuilder()
        .withErrorNotification('Failed to create process mining')
        .withOnError((error) => {
          telemetry.captureError(error);
          setLoading(false);
        })
        .execute(async () => {
          setLoading(true);
          const { funnels, funnelsData } = await post_aiProcessMining({ objectName });

          const funnelsToAdd: { funnel: Funnel; position: FunnelMapPosition }[] = Object.entries(
            funnels,
          )
            .filter(([funnelId]) => Boolean(funnelsData[funnelId]))
            .map(([funnelId, position]) => ({
              funnel: funnelsData[funnelId],
              position: position.position,
            }));

          if (funnelsToAdd.length > 0) {
            dispatch(addMultipleSfFunnels(funnelsToAdd));
            setTimeout(() => {
              fitView();
            }, 1000);
          }

          setLoading(false);
          maybeClosePanel();
        });
    },
    [errorHandlingBuilder, post_aiProcessMining, dispatch, fitView],
  );

  return (
    <PanelConsumer panelType={processMiningPanelType}>
      {({ maybeClosePanel, isOpen }) => (
        <>
          {isOpen && (
            <ProcessMiningDialog
              crmOrgId={crmOrgId}
              onCancel={maybeClosePanel}
              onConfirm={onConfirm(maybeClosePanel)}
              loading={loading}
            />
          )}
        </>
      )}
    </PanelConsumer>
  );
};
